const schemas = {
  highroller: (data) => {
    const birthdate = new Date(data.user.birthdate);

    return {
      email: data.credentials.email,
      password: data.credentials.password,
      username: data.credentials.username,
      currency: data.user.currency,
      selectedBonus: data.user.selectedBonus,
      bonuseCode: data.user.bonuseCode || '',
      firstname: data.user.firstName,
      lastname: data.user.lastName,
      birthdate: birthdate && birthdate.toISOString().split('T')[0],
      country: data.user.country,
      state: data.user.province,
      stateName: data.user.provinceName,
      phone: data.user.phone,
      phoneWithoutPrefix: data.user.phoneWithoutPrefix,
      phoneE164: data.user.phoneE164,
      phoneCountry: data.user.phoneCountry,
      phonePrefix: data.user.phonePrefix,
      city: data.user.city,
      postalCode: data.user.postalCode,
      gender: data.user.gender,
      address: `${data.user.streetName} ${data.user.houseNumber}`,
      consent: data.consent,
      // PEP check
      sanctions: data.sanction.flag,
      recaptchaData: data.user.recaptcha || undefined,
    }
  }
}

const transformData = (data, schema) => schemas[schema](data)

export default transformData



// WEBPACK FOOTER //
// ./src/utils/data-transfrom.js